import './index.scss';
import { Box } from '@mui/material';
import { useFilterContext } from '../../services/mVPMapService/filterContext';
import { MVPFormData } from './constants';
import React, { useCallback } from 'react';
import { MVPSidebar } from '../sideBar';

export const AdvantaMVPCharts: React.FC = () => {
  const { filterValues, setFilterValues } =
    useFilterContext();

  const filtersIsCollapsed = false;
  const handleApplyFilter = useCallback(
    (values: MVPFormData) => {
      setFilterValues((prevValues) => ({
        ...prevValues,
        ...values,
      }));
    },
    [setFilterValues]
  );

  return (
    <>
      <Box className="filter-and-charts-container">
        <MVPSidebar
          filterValues={filterValues}
          filtersIsCollapsed={filtersIsCollapsed}
          handleApplyFilter={handleApplyFilter}
        />
      </Box>
    </>
  );
};
